import { render, staticRenderFns } from "./Player2021.vue?vue&type=template&id=203cddc0&"
import script from "./Player2021.vue?vue&type=script&lang=js&"
export * from "./Player2021.vue?vue&type=script&lang=js&"
import style0 from "./Player2021.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports